    /**
     * @ngdoc control
     * @name EmailSaveSuccessToast
     * 
     * @description
     * Controller which is used for showing the toast when the automated email save process was successfully completed
     */

(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmailSaveSuccessToast', EmailSaveSuccessToast);

    EmailSaveSuccessToast.$inject = ['$scope', '$mdToast', 'toastText'];

    function EmailSaveSuccessToast($scope, $mdToast, toastText) {
        $scope.toastText = toastText;
        $scope.close = close;

        function close() {
            $mdToast.hide();
        }
    }
})();
